/*
 * @Description: 计费规则设置及详情
 * @Author: huzhibo
 * @Email: hzbfun@gmail.com
 * @Date: 2020/11/23 11:30
 */

export default {
  data() {
    return {
      // 规则数据
      formData: {
        contractId: "", // 合同id
        contractCode: "", // 合同编号
        contractName: "", // 合同名称
        contractType: "", // 合同类型：1-采购合同，2-销售合同
        partyA: "", // 甲方
        partyB: "", // 乙方
        feeItemRule: "", // 若对应费目项，同时匹配到多个计费规则： 1-以最低为准； 2-以最高为准
        billingCycle: "", // 计费周期：1-按单计费，2-按日计费，3-包天价 （暂无按日计费的业务）
        pieceCountType: "0", // 件数设置：0-标准件数，1-向上取整
        feeItems: []
      }
    };
  },

  computed: {
    // 查询详情的参数
    queryParams() {
      const { contractCode, version = "" } = this.$route.query;
      return {
        contractCode,
        version
      };
    }
  },

  methods: {
    // 重置页面数据
    handleReset() {
      this.formData = {
        contractId: "", // 合同id
        contractCode: "", // 合同编号
        contractName: "", // 合同名称
        contractType: "", // 合同类型：1-采购合同，2-销售合同
        partyA: "", // 甲方
        partyB: "", // 乙方
        feeItemRule: "", // 若对应费目项，同时匹配到多个计费规则： 1-以最低为准； 2-以最高为准
        billingCycle: "", // 计费周期：1-按单计费，2-按日计费，3-包天价 （暂无按日计费的业务）
        pieceCountType: "0", // 件数设置：0-标准件数，1-向上取整
        feeItems: []
      };
    }
  }
};
